export const getAwsConfig = () => {

  const baseApiInfo = process.env.REACT_APP_API_INFO;
  const baseAuthInfo = process.env.REACT_APP_AUTH_INFO;
  const appType = process.env.REACT_APP_APP_TYPE;

  if (baseApiInfo == null || 
      baseAuthInfo == null || 
      appType == null) {
    throw Error('Environment variable not defined')
  }
  
  let basepath = '';
  const basename = process.env.REACT_APP_BASENAME;
  if (basename != null && basename != '') {
    basepath = basename.slice(1) + '/';
  }
  
  // console.log('baseApiInfo = ' + baseApiInfo);
  // console.log('baseAuthInfo = ' + baseAuthInfo);
  
  const apiInfo = baseApiInfo.split(',');
  const authInfo = baseAuthInfo.split(',');

  // Auth
  const authRegion = authInfo[0];
  const authUserPoolId = authInfo[1];
  const authUserPoolWebClientId = authInfo[2];
  const authIdentityPoolId = authInfo[3];
  const authUserPoolSubDomain = authInfo[4];
  const authFrontendUrl = authInfo[5];
  
  const authConfig = {
    identityPoolId: authIdentityPoolId,
    region: authRegion,
    userPoolId: authUserPoolId,
    userPoolWebClientId: authUserPoolWebClientId,
    storage: window.localStorage,
    oauth: {
      domain: `${authUserPoolSubDomain}.auth.${authRegion}.amazoncognito.com`,
      scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: `${authFrontendUrl}${basepath}index.html`,
      redirectSignOut: `${authFrontendUrl}${basepath}login.html`,
      responseType: 'code'
    }
  };
  
  // API
  let backendApiUrl = apiInfo[0];
  if (apiInfo[0] === '' && apiInfo.length === 3) {
    // カスタムドメイン設定あり
    backendApiUrl = 'https://' + apiInfo[1];
  }
  // console.log(backendApiUrl);
  
  return ({
    aws_project_region: authRegion,
    Auth: authConfig,
    API: {
      endpoints: [
        {
          name: 'BackendApi',
          endpoint: backendApiUrl
        }
      ]
    }
  });
};
